// call onClose() without arguments for modal to avoid ON_HIDE middleware callbacks
export const closeModalWithoutCallback = onClose => onClose();
